import { render } from "./GamesCard.vue?vue&type=template&id=95acb074&scoped=true&bindings={\"game\":\"props\"}"
import script from "./GamesCard.vue?vue&type=script&lang=js"
export * from "./GamesCard.vue?vue&type=script&lang=js"

import "./GamesCard.vue?vue&type=style&index=0&id=95acb074&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-95acb074"

export default script